import React from 'react';

import classNames from 'classnames';

export const Menu = ({ className, children }) => {
	return (
		<div className={classNames(className, 'wds-menu')}>{children}</div>
	)
}
